import { default as Component } from '../../../../components/qaOverrides';

export default () => {
  return {
    Component,
  };
};
